
export const cardNumber = {
    636795: 'بانک مرکزی جمهوری اسلامی ایران',
    603799: 'بانک ملی ایران',
    589210: 'بانک سپه',
    627648: 'بانک توسعه صادرات',
    207177: 'بانک توسعه صادرات',
    627961: 'بانک صنعت و معدن',
    603770: 'بانک کشاورزی',
    639217: 'بانک کشاورزی',
    628023: 'بانک مسکن',
    627760: 'پست بانک ایران',
    502908: 'بانک توسعه تعاون',
    627412: 'بانک اقتصاد نوین',
    622106: 'بانک پارسیان',
    502229: 'بانک پاسارگاد',
    639347: 'بانک پاسارگاد',
    627488: 'بانک کارآفرین',
    621986: 'بانک سامان',
    639346: 'بانک سینا',
    639607: 'بانک سرمایه',
    502806: 'بانک شهر',
    502938: 'بانک دی',
    603769: 'بانک صادرات ایران',
    610433: 'بانک ملت',
    991975: 'بانک ملت',
    627353: 'بانک تجارت',
    589463: 'بانک رفاه کارگران',
    627381: 'بانک انصار',
    639370: 'بانک مهر ایران',
    606373: 'بانک مهر ایران',
    636214: 'بانک آینده',
    505416: 'بانک گردشگری',
    636949: 'بانک حکمت ایرانیان',
    505785: 'بانک ایران زمین',
}